import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { TopStatistic } from '../topStatistic';
import { BottomStatistic } from '../bottomStatistics';
import { BACCARAT_STATISTICS_TYPES } from '../../../enums/constants';
import { statisticWinnerListHandler } from '../../../helpers/statisticWinnerList';
import { bigRoadStatisticCreateHandler } from '../../../helpers/bigRoad';
import { roundsWinBetTypes } from '../../../store/roundsWinBetTypes';

export const AllStatistics = observer(() => {
  const { winBetTypes } = roundsWinBetTypes;

  const statisticList = useMemo(() => {
    if (winBetTypes) {
      return {
        first: statisticWinnerListHandler(winBetTypes) || [],
        second: statisticWinnerListHandler(
          bigRoadStatisticCreateHandler(
            statisticWinnerListHandler(winBetTypes),
            BACCARAT_STATISTICS_TYPES.BIG_ROAD1
          )
        ),
        third: statisticWinnerListHandler(
          bigRoadStatisticCreateHandler(
            statisticWinnerListHandler(winBetTypes),
            BACCARAT_STATISTICS_TYPES.BIG_ROAD2
          )
        ),
        fourth: statisticWinnerListHandler(
          bigRoadStatisticCreateHandler(
            statisticWinnerListHandler(winBetTypes),
            BACCARAT_STATISTICS_TYPES.BIG_ROAD3
          )
        ),
      };
    }
    return null;
  }, [winBetTypes]);

  if (!statisticList) {
    return null;
  }

  return (
    <div className='bb-bet-section-right-col'>
      <TopStatistic statisticList={statisticList.first} />
      <div className='bb-bet-section-row bb-bet-section-row-bottom'>
        <BottomStatistic
          statisticList={statisticList.second}
          statisticType={BACCARAT_STATISTICS_TYPES.BIG_ROAD1}
        />
        <BottomStatistic
          statisticList={statisticList.third}
          statisticType={BACCARAT_STATISTICS_TYPES.BIG_ROAD2}
        />
        <BottomStatistic
          statisticList={statisticList.fourth}
          statisticType={BACCARAT_STATISTICS_TYPES.BIG_ROAD3}
        />
      </div>
    </div>
  );
});
